<style>
    @import "./vip.less";
</style>

<template>
    <div class="lawJudgement">
        <div class="lawJudgement_con">
            <img src="./lawcomponent/images/lawjudgeback.png" alt='版权登记'/>
        </div>
        <div class="lawJudgement_fr_content">
            <img src="./lawcomponent/images/lawissue1.png" alt='版权登记'/>
            <div class="lawJudgement_fr_content_rig">
                <p class="rg_title">出具律师函</p>
                <p class="rg_tw_title">被侵权，对方不配合，可利用法律手段解决</p>
                <p class="rg_th_title">服务内容：</p>
                <div class="rg_th_title_fr">
                    <p>1、</p>
                    <p>由版权家合作或自营律师事务所为您开具具有法律效力的法律函</p>
                </div>
                <p v-if="lawyerConsultNum>0" class="vipstyle">您是{{ userInfo.accountType == 'person' ? '个人' : '企业' }}VIP会员，当前剩余{{lawyerConsultNum}}次法律服务</p>
                <input class="goOrderEsc" @click="oneSubmit" type="button" value="下单"/>
            </div>
        </div>
        <div class="lawJudgement_parcontent">
            <div class="lawJudgement_cont_title">
                <div>您可能还需要以下服务</div>
                <p></P>
            </div>
            <div style="padding-top:240px">
                <lawCommon active-id="4"/>
            </div>
        </div>
        <div class="lawJudgement_three">
            <div class="law_thre_content">
                <p class="th_title">C<br/>O<br/>P<br/>Y<br/>R<br/>I<br/>G<br/>H<br/>T</p>
                <img src="./lawcomponent/images/lawjudge1.png" alt='版权登记'/>
                <div class="th_thcontent">
                    <img style="margin-top:60px;" src="./lawcomponent/images/lawjudge5.png" alt='版权登记'/>
                    <p style="margin-top:30px;" class="th_pf">根据《著作权法》第48条的规定</p>
                    <p style="margin-top:30px;" class="th_ps">侵犯著作权，侵权人应当按照权利人的实际损失给予赔偿</p>
                    <p style="margin-top:15px;margin-bottom:15px;" class="th_ps">实际损失难以计算的，不能确定的，由人民法院根据侵权行为</p>
                    <p class="th_ps">的情节，判决给予50万元以下的赔偿。</p>
                </div>
            </div>
        </div>
        <div class="lawJudgement_four" style="padding-top:50px;padding-bottom:80px">
            <lawcommontw :content="content" :title="title"/>
            <img src="./lawcomponent/images/lawjudge2.png" alt='版权登记'/>
        </div>
        <!--    出具律师函    -->
        <generalframe @fatherMethod="fatherMethod" v-show="showDialog" maintitle="出具律师函" mywidth="800" myheight="600" ref="mychild">
            <div class="ts_content">
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p>接听手机：</p>
                    <input v-model="serviceManPhone" style="flex:1" type="text" maxLength="11"
                           placeholder="请输入11位手机号码"/>
                </div>
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p>描述：</p>
                    <textarea maxlength="500" v-model="questionDesc" style="flex:1;min-height:120px;resize: none;"
                              placeholder="请输入您需要判定的简要描述"></textarea>
                </div>
                <div v-if="showDialog" class="ts_content_fr" style="line-height: 42px;">
                    <p>支付方式：</p>
                    <pay-way
                        @onselected="payWay = $event"
                        type="0506">
                    </pay-way>
                </div>
                <input class="goOrderEsc" @click="this.sureOrder" type="button" value="确认下单"/>
            </div>
        </generalframe>
        <!--    加油包    -->
        <monitorBag bizType="05" v-if="monitorBagState" @monitorBagFather="monitorBagFuc"/>
        <!--    会员续费    -->
        <myczPay v-if="myczPayState" mywidth='838' myheight="585" myTitleheight="50" @fatherModal="myczPayFuc"/>
    </div>
</template>

<script>
    import lawcommontw from './lawcomponent/lawcomponenttw.vue'
    import lawCommon from './lawcomponent/lawcomponentbl.vue'
    import generalframe from './lawcomponent/generalframe.vue'
    import monitorBag from '@/views/vipClip/monitor/components/monitorBag';
    import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay'
    import util from '@/libs/util';
    import Cookies from "js-cookie";
    import {getAddLawyerLetter,getVipMemberright} from '@/api/staticPage';
    import payWay from '@/views/main-components/pay-way';

    export default {
        metaInfo: {
            title: '出具律师函|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '出具律师函,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'lawIssue',
        components: {
            lawcommontw,
            lawCommon,
            generalframe,
            monitorBag,
            myczPay,
            payWay
        },
        data() {
            return {
                userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                content: [
                    {content: '预约律师，确认下单', english: 'ONE'},
                    {content: '等待律师，电话联系', english: 'TWO'},
                    {content: '双方沟通，解答问题', english: 'THREE'},
                    {content: '服务完成，平台回访', english: 'FOUR'},
                ],
                title: '律师服务流程',
                showDialog: !1,
                lawyerConsultNum: 0, //法律服务剩余次数
                questionDesc: '',
                serviceManPhone: '',
                monitorBagState: false, //加油包模态框展示状态
                myczPayState: false, //会员监测模态框展示状态
                payWay: null,
            }
        },
        watch:{
	    	"$store.state.app.showPayWay":function(){
	    		if(Cookies.get("userInfo")){
	    			this.userInfo = JSON.parse(Cookies.get("userInfo"))
	    		}
	    	}
	    },
        methods: {
            /****************提交出具律师函**************/
            _getAddLawyerLetter() {
                let _this = this;
                let userInfo = this.userInfo;
                let params = {
                    registerId:userInfo && userInfo.id?userInfo.id:'',
                    callbackMobilePhone: _this.serviceManPhone,
                    questionDesc: _this.questionDesc
                };
                if (this.payWay && this.payWay.gift && this.payWay.gift.countNumber) {
                    Object.assign(params, {activityGiftId: this.payWay.activityGiftId && this.payWay.activityGiftId!='' ? this.payWay.activityGiftId : ''})
                } else {
                    toast('无可用次数')
                    return;
                }
                getAddLawyerLetter(params).then(res => {
                    console.log(res);

                    let message = res.message;
                    let _this = this;

                    //1.用户未实名；2.VIP未开通；3.VIP已到期；4.加油包

                    switch (res.code) {
                        case 200 : {
                            this.lawyerConsultNum = this.lawyerConsultNum - 1;

                            this.fatherMethod();
                            toast('提交成功！请前往【个人中心】查看订单服务详情');
                            break;
                        }

                        //VIP已到期--弹框
                        case 215: {
                            toast(message, () => {
                                this.myczPayState = true;
                            });
                            break;
                        }

                        //次数不够--弹出加油包
                        case 216 : {
                            this.monitorBagState = true;
                            break;
                        }

                        default:
                            toast(message);
                            break;

                    }


                }, (err) => {
                    toast('提交失败，请重试');
                })
            },

            /************服务次数接口***********/
            _getVipMemberright() {
                let _this = this;
                let userInfo = this.userInfo;

                if(userInfo && userInfo!='' && userInfo.vipFlag!=0){
                    let params = {
                        registerId: userInfo && userInfo.id ? userInfo.id : '',
                    };
                    getVipMemberright(params).then(res => {
                        if (res.code == 200) {
                            this.lawyerConsultNum = res.result.lawyerConsultNum;
                        }
                    })
                }

            },

            /****************打开出具律师函模态框**************/
            goOrder() {
                let _this = this;
                _this.showDialog = !0
            },

            /****************关闭出具律师函模态框**************/
            fatherMethod() {
                let _this = this;
                _this.showDialog = !1;
                _this.serviceManPhone = '';
                _this.questionDesc = '';
            },

            /****************第一步-提交**************/
            oneSubmit() {
                let userInfo = this.userInfo;
                console.log(userInfo);
                if (userInfo == '') {
                	this.$store.state.app.showLoginOrRegistter = true
                    return false;
                }
                this.goOrder();
            },

            /****************第二步-确认下单**************/
            sureOrder() {
                let questionDesc=this.questionDesc.replace(/^\s+|\s+$/g,'');
                let _this = this;

                if (!util.checkPhoneNum(_this.serviceManPhone)) {
                    toast('请填写正确的手机号再提交');
                } else if (questionDesc == '') {
                    toast('请填写完整后再提交');
                } else {
                    _this._getAddLawyerLetter()
                }
            },

            /****************接收加油包组件传值**************/
            monitorBagFuc(value) {
                this.monitorBagState = false;
            },

            /****************接收会员续费组件传值**************/
            myczPayFuc() {
                console.log('会员续费弹框');
                this.myczPayState = false;
            },


        },
        mounted() {
            this._getVipMemberright();
        }
    }
</script>

<style scoped lang="less">
    .lawJudgement {
        .ts_content {
            padding: 30px;

            .ts_content_fr {
                display: flex;
                justify-content: flex-start;

                p {
                    width: 70px;
                    text-align: left;
                    margin-right: 10px;
                }
            }
        }

        .goOrderEsc {
            margin-top: 20px;
            width: 137px;
            height: 42px;
            background: rgba(255, 216, 0, 1);
            border-radius: 2px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            line-height: 42px;
            outline: none;
            border: none;
            cursor: pointer;
        }

        .lawJudgement_con {
            height: 422px;

            img {
                max-width: 100%;
                display: block;
                height: 100%;
            }
        }

        .lawJudgement_fr_content {
            width: 1334px;
            height: 455px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            border-radius: 4px;
            left: 0;
            right: 0;
            margin: auto;
            margin-top: -400px;
            z-index: 555;
            position: absolute;
            display: flex;
            justify-content: flex-start;

            img {
                width: 506px;
                height: 411px;
                margin: 22px;
                margin-right: 0px;
            }

            .lawJudgement_fr_content_rig {
                margin-left: 37px;

                .rg_title {
                    height: 28px;
                    font-size: 20px;
                    font-weight: bold;
                    color: rgba(65, 65, 65, 1);
                    line-height: 28px;
                    margin-top: 40px;
                }

                .rg_tw_title {
                    height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(65, 65, 65, 1);
                    line-height: 20px;
                    margin-top: 10px;
                    margin-bottom: 40px;
                }

                .rg_th_title {
                    height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(65, 65, 65, 1);
                    line-height: 20px;
                    margin-bottom: 10px;
                }

                .rg_th_title_fr {
                    display: flex;
                    justify-content: flex-start;

                    p:first-child {
                        width: 23px;
                        height: 20px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(65, 65, 65, 1);
                        line-height: 20px;
                    }

                    P:last-child {
                        width: 467px;
                        height: 20px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(65, 65, 65, 1);
                        line-height: 20px;
                    }
                }

                .rg_th_title_se {
                    display: flex;
                    justify-content: flex-start;
                    margin-top: 15px;

                    p:first-child {
                        width: 23px;
                        height: 20px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(65, 65, 65, 1);
                        line-height: 20px;
                    }

                    P:last-child {
                        height: 20px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(65, 65, 65, 1);
                        line-height: 20px;
                    }
                }

                input {
                    width: 137px;
                    height: 42px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 2px;
                    border: 1px solid rgba(199, 199, 199, 1);
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    line-height: 42px;
                    cursor: pointer;
                    outline: none;
                    margin-right: 20px;
                    margin-bottom: 20px;

                    &:hover {
                        background: rgba(255, 216, 0, 1);
                        border: none;
                    }
                }

                .active {
                    width: 137px;
                    height: 42px;
                    background: rgba(255, 216, 0, 1);
                    border-radius: 2px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    line-height: 42px;
                    cursor: pointer;
                    outline: none;
                    border: none;
                    margin-right: 20px;
                    margin-bottom: 20px;
                }

                .vipstyle {
                    height: 20px;
                    font-size: 14px;
                    font-weight: bold;
                    color: rgba(37, 37, 37, 1);
                    line-height: 20px;
                    margin-top: 135px;
                }

                .goOrderEsc {
                    margin-top: 20px;
                    width: 137px;
                    height: 42px;
                    background: rgba(255, 216, 0, 1);
                    border-radius: 2px;
                    font-size: 14px;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                    line-height: 42px;
                    outline: none;
                    border: none;
                    cursor: pointer;
                }
            }
        }

        .lawJudgement_parcontent {
            height: 597px;
            background: rgba(250, 252, 254, 1);

            .lawJudgement_cont_title {
                width: 1334px;
                margin: 0 auto;
                position: relative;
                top: 94px;

                div {
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin: auto;
                    z-index: 3;
                    top: 56px;
                    text-align: center;
                    font-size: 30px;
                    font-weight: 400;
                    color: rgba(4, 4, 4, 1);
                    letter-spacing: 3px;
                }

                p {
                    width: 55px;
                    height: 55px;
                    background: rgba(255, 216, 0, 1);
                    border-radius: 50%;
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin: auto;
                    z-index: 2;
                    top: 50px;
                }
            }
        }

        .lawJudgement_three {
            height: 321px;
            background: rgba(250, 252, 254, 1);

            .law_thre_content {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 1334px;
                margin: 0 auto;
                height: 321px;

                .th_title {
                    width: 18px;
                    height: 306px;
                    font-size: 25px;
                    font-weight: 800;
                    color: rgba(216, 216, 216, 1);
                    line-height: 34px;
                }

                img {
                    width: 506px;
                    height: 321px;
                    margin-left: 17px;
                    margin-right: 85px;
                }

                .th_thcontent {
                    height: 321px;

                    img {
                        width: 28px;
                        height: 25px;
                        margin-left: 0px;
                        margin-right: 0px;
                    }

                    .th_pf {
                        height: 28px;
                        font-size: 20px;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        line-height: 28px;
                    }

                    .th_ps {
                        height: 21px;
                        font-size: 15px;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        line-height: 21px;
                    }
                }
            }
        }

        .lawJudgement_four {
            height: 656px;
            width: 1334px;
            margin: 0 auto;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
                width: 667px;
                height: 456px;
            }
        }
    }
</style>